"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = useFirestoreConnect;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual")),
    _react = require("react"),
    _utils = require("./utils"),
    _useFirestore = _interopRequireDefault(require("./useFirestore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useFirestoreConnect(queriesConfigs) {
  var firestore = (0, _useFirestore.default)(),
      firestoreIsEnabled = !!firestore,
      queryRef = (0, _react.useRef)(),
      data = (0, _react.useMemo)(function () {
    return (0, _utils.invokeArrayQuery)(queriesConfigs);
  }, [queriesConfigs]);
  (0, _react.useEffect)(function () {
    if (firestoreIsEnabled && !(0, _isEqual2.default)(data, queryRef.current)) {
      var changes = (0, _utils.getChanges)(data, queryRef.current);
      queryRef.current = data, firestore.unsetListeners(changes.removed), firestore.setListeners(changes.added);
    }
  }, [data]), (0, _react.useEffect)(function () {
    return function () {
      firestoreIsEnabled && queryRef.current && firestore.unsetListeners(queryRef.current);
    };
  }, []);
}

module.exports = exports.default;